import { ReactNode } from 'react';

export function navTitleToTestSegment(title: ReactNode): string {
  if (typeof title === 'string' || typeof title === 'number') {
    const s = String(title)
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
    return s || 'item';
  }
  return 'item';
}

export function navLinkToTestSegment(link: string): string {
  const pathOnly = link.split('?')[0] ?? '';
  const seg =
    pathOnly
      .replace(/^\//, '')
      .replace(/\//g, '-')
      .replace(/[^a-zA-Z0-9-]/g, '-') || 'root';
  return seg.replace(/-+/g, '-').replace(/^-|-$/g, '') || 'root';
}
